import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { SharingDataService } from "src/app/Services/sharing-data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthentService } from "src/app/Services/authent.service";
import { FormGroup, FormControl } from "@angular/forms";
import { UserService } from "../../user.service";
import { CommonService } from "src/app/Services/common.service";
import { DownloadService } from "src/app/workflow/download/download.service";
import { ErrorHandlingService } from "src/app/Services/errorHandling.service";
import { TranslateResourceDefinitionPipe } from "src/app/shared/pipes/translateResourceDefinition.pipe";

@Component({
  selector: "app-gip-user-logon",
  templateUrl: "./gipUserLogon.component.html",
  styleUrls: ["./gipUserLogon.component.css"],
})
export class GipUserLogonComponent implements OnInit {
  @Output() public submit = new EventEmitter();
  constructor(
    private route: ActivatedRoute,
    private authService: AuthentService,
    private userService: UserService,
    private router: Router,
    private shareData: SharingDataService,
    private commonService: CommonService,
    private downloadService: DownloadService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe
  ) {}

  resourceDefinition;
  return: string = "";
  groupName= "LOGIN";

  modelInput = new FormGroup({
    Login: new FormControl(),
    Password: new FormControl(),
    AcceptTermOfUse: new FormControl(),
    ReadDataProtection: new FormControl(),
    DownloadTermsOfUse: new FormControl(),
  });

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(
      (data) => (this.resourceDefinition = data)
    );
    this.route.queryParams.subscribe(
      (params) => (this.return = params["return"])
    );
  }

  statusIncorrectLogin = false;

  isLoginEnabled() {
    return (
      this.modelInput.value.ReadDataProtection &&
      this.modelInput.value.AcceptTermOfUse &&
      this.modelInput.status == "VALID"
    );
  }

  getAcceptTermOfUse(){
    var text = this.translateResourceDefinition.transform('AcceptTermOfUse', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    var placeholder = this.translateResourceDefinition.transform('LinkTerms', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    text = text.replace('{0}', `<p class="linka">&nbsp;${placeholder}&nbsp;</p>`)
    return text;
  }

  getReadDataProtection(){
    var text = this.translateResourceDefinition.transform('ReadDataProtection', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    var placeholder = this.translateResourceDefinition.transform('SID_DataProtection', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    text = text.replace('{0}', `<p class="linkr">&nbsp;${placeholder}&nbsp;</p>`)
    return text;
  }

  formular = [
    { formControlName: "Login", visible: true, required: true, inputString: true},
    { formControlName: "Password", newRow: true, visible: true, required: true, password: true, type: "password" },
    // { formControlName: "AcceptTermOfUse", newRow: true, visible: true, required: true, checkbox: true },
    // { formControlName: "ReadDataProtection", newRow: true, visible: true, required: true, checkbox: true },
    // { formControlName: "LinkTerms", visible: true, link: true, function: "download", title: "MoreInformation"},
  ];

  action(action) {
    this[action]();
  }

  onSubmit() {
    this.submit.emit();
  }

  login() {
    this.authService.login(this.modelInput.value.Login, this.modelInput.value.Password, this.return)
  }

  download(event) {
    if(event.srcElement.className == "linka"){
      this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/TermsOfUseFile', undefined, (response) => {
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDoesntExist', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      });
    }
    if(event.srcElement.className == "linkr"){
      this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/DataProtectionFile', undefined, (response) => {
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDoesntExist', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      });
    }
  }
}